var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function Label(_a) {
    var id = _a.id, isStepsMode = _a.isStepsMode, max = _a.max, value = _a.value, customLabel = _a.customLabel;
    var roundedVal = Math.floor(value);
    return (_jsx("label", __assign({ htmlFor: id }, { children: customLabel ? (customLabel) : (_jsx("span", __assign({ "aria-hidden": "true" }, { children: isStepsMode
                ? "".concat(roundedVal, " / ").concat(max)
                : "".concat(Math.floor((roundedVal / max) * 100), "%") }))) })));
}
export default Label;
